// Vue
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
// Template
import template from "./template.vue";

@Component({
  mixins: [template],
})
export default class Galery extends Vue {
  @Prop()
  konsi!: object;

  @Prop()
  translation!: object;

  selectedImage = 0;

  public showImage(index) {
    this.selectedImage = index;
  }

  public slideTo(action) {
    switch (action) {
      case "prev":
        this.selectedImage =
          this.selectedImage > 0 ? this.selectedImage - 1 : this.selectedImage;
        break;
      case "next":
        this.selectedImage =
          this.selectedImage < this.konsi["images"].length - 1
            ? this.selectedImage + 1
            : this.selectedImage;
        break;
    }
  }
}
